export default __webpack_public_path__ + "static/P_SearchThumb_IN-9008HD-423e7dee1aa62012a3a723cf4254f1c8.webp";